import { createApp } from 'vue';
import Erecepta from './components/Erecepta/Erecepta.vue';
import Ezwolnienie from './components/Ezwolnienie/Ezwolnienie.vue';
import Tabletka from './components/Tabletka/Tabletka.vue';
import Antykoncepcja from './components/Antykoncepcja/Antykoncepcja.vue';
import Eskierowanie from './components/Eskierowanie/Eskierowanie.vue';

const app = createApp({});

app.component('erecepta', Erecepta);
app.component('ezwolnienie', Ezwolnienie);
app.component('tabletka', Tabletka);
app.component('antykoncepcja', Antykoncepcja);
app.component('eskierowanie', Eskierowanie);

app.mount('#app');
